import { get } from '../baseService'

const create = () => {
  const getTaskStatus = (id: string) =>
    get(`/config-api/importTask/status?&id=${id}`, false, true)
  const getTasks = (dateFrom: string, dateTo: string) =>
    get(
      `/config-api/importTask/all?&dateFrom=${dateFrom}&dateTo=${dateTo}`,
      false,
      true,
    )

  return {
    getTaskStatus,
    getTasks,
  }
}

export default {
  create,
}
